type ClassValue = string | number | false | null | undefined;

/**
 * Joins class names, dropping falsy ones. Deliberately not `clsx` + `tailwind-merge`:
 * nothing here composes classes deeply enough to need conflict resolution.
 */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
